import React from 'react';
import { FadeIn } from './FadeIn';
import { XIcon } from 'lucide-react';
export function PainPoints() {
  const points = ['No sabés cómo periodizar la nutrición según el deporte', 'Improvisás planes sin protocolos claros', 'Te preguntan por suplementos y no tenés respuestas con evidencia', 'Perdés pacientes deportistas por falta de especialización', 'Sabés que es una oportunidad, pero te falta el sistema'];
  return <section className="pt-8 pb-10 px-3 bg-surface border-y border-accent/10" data-id="element-197">
      <div className="max-w-3xl mx-auto" data-id="element-198">
        <FadeIn data-id="element-199">
          <h2 className="text-center text-xl md:text-2xl font-bold mb-6" data-id="element-200">
            <span className="text-white" data-id="element-201">Si sos nutricionista,</span>{' '}
            <span className="text-accent" data-id="element-202">esto te va a sonar familiar:</span>
          </h2>
        </FadeIn>

        <div className="space-y-3 mb-8 max-w-2xl mx-auto" data-id="element-203">
          {points.map((point, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-204">
              <div className="flex items-start gap-3 bg-black/50 p-3 rounded-lg border border-white/5" data-id="element-205">
                <XIcon className="text-red-400 shrink-0 mt-0.5" size={18} data-id="element-206" />
                <span className="text-white/80 text-sm md:text-base" data-id="element-207">
                  {point}
                </span>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.8} data-id="element-208">
          <p className="text-center text-lg md:text-xl italic max-w-2xl mx-auto font-[900] font-['Open_Sans',_sans-serif] text-accent" data-id="element-209">
            Tu inseguridad profesional tiene solución.
          </p>
        </FadeIn>
      </div>
    </section>;
}